export const dashboardTabTriggerProps = {
  rounded: "lg",
  px: "3",
  py: "2.5",
  color: "dashboard.fg.muted",
  fontWeight: "500",
  transition: "background 150ms ease, color 150ms ease",
  _hover: { bg: "dashboard.bg.surfaceMuted" },
  _selected: {
    bg: "dashboard.bg.surfaceMuted",
    color: "dashboard.accent.fg",
    fontWeight: "600",
  },
};
